export function getCheckoutPlanCode(planName: string): string {
  switch (planName) {
    case "Plus":
      return "plus-annual";
    case "Pro":
      return "pro-yearly";
    case "Enterprise":
      return "enterprise-annual";
    default:
      return "pro-yearly";
  }
}
